import logo from '../../assets/brand/chatbizai-logo.png';

/** Brand logo. Shown on a white chip so the dark lettering stays readable on the blue sidebar. */
export default function Brand() {
  return (
    <div className="cb-brand">
      <span className="cb-brand__chip"><img src={logo} alt="ChatBizzAI - Advanced AI Support Chat Bot" /></span>
    </div>
  );
}
